export const GET_PROFILE = 'app/AddRepertoire/GET_PROFILE';
export const GET_PROFESSIONS = 'app/AddRepertoire/GET_PROFESSIONS';
export const GET_ROLES = 'app/AddRepertoire/GET_ROLES';
export const ADD_REPERTOIRE = 'app/AddRepertoire/ADD_REPERTOIRE';
export const GET_MW_LIST = 'app/AddRepertoire/GET_MW_LIST';
export const GET_COMPOSERS_LIST = 'app/AddRepertoire/GET_COMPOSERS_LIST';
export const RESET_LIST = 'app/AddRepertoire/RESET_LIST';
